import React from 'react';
import { LiveCameraModal } from '../components';

interface IProfilePictureModalContainerProps {
  isOpen: boolean;
  profileLink: string;
  firstName: string;
  lastName: string;
  userRole: string;
  onProfileLinkChange: (url: string) => void;
  onOpenChange: (open: boolean) => void;
}

export const ProfilePictureModalContainer = ({
  isOpen,
  profileLink,
  firstName,
  lastName,
  userRole,
  onProfileLinkChange,
  onOpenChange,
}: IProfilePictureModalContainerProps) => {
  if (!isOpen) return null;

  return (
    <LiveCameraModal
      isOpen={isOpen}
      setIsModalOpen={onOpenChange}
      setProfileLink={onProfileLinkChange}
      currentProfilePic={profileLink}
      userName={`${firstName} ${lastName}`}
      userRole={userRole}
    />
  );
};
